export default __webpack_public_path__ + "static/6-2174bf891abe504a3dc9d1c13bf33789.png";